import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import TypewriterEffect from "./TypewriterEffect";
import heroImage from "./chat.png"; // Re-import heroImage
import ChatbotModal from "./ChatbotModal"; // Re-import ChatbotModal

const HeroSection = ({ handleShowContactModal }) => {
  const [showChatbot, setShowChatbot] = useState(false); // Re-introduce local state

  const fullText = "Your AI.\nYour Premises.\nYour Control.";

  // No need for scrollToSection here as it's not directly used for hero section buttons

  return (
    <div className="section-container hero-background-gradient">
      <div className="hero-content-wrapper">
        {/* Left Content Section */}
        <div className="hero-left-content section-padding flex-col justify-center fade-in">
          <div className="section-tag font-weight-600 text-uppercase letter-spacing-1 slide-up">
            Private AI Platform
          </div>

          <h1 className="section-title font-weight-600 slide-up" style={{ minHeight: "120px", whiteSpace: "pre-wrap" }}>
            <TypewriterEffect text={fullText} typingSpeed={65} />
          </h1>

          <div className="hero-description-container">
            <span className="hero-description-line slide-up" dangerouslySetInnerHTML={{ __html: "**Enterprise AI.** On your premises. No cloud risks.".replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
            <span className="hero-description-line slide-up" dangerouslySetInnerHTML={{ __html: "**Absolute data sovereignty.** Immune to foreign laws.".replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
            <span className="hero-description-line-last slide-up" dangerouslySetInnerHTML={{ __html: "**True AI liberty.** Complete AI sovereignty.".replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
          </div>

          <div className="hero-cta-buttons-container margin-bottom-24 slide-up">
            <button
              className="hover-button btn-primary"
              onClick={handleShowContactModal}
            >
              Book a Demo
            </button>
            <button
              className="hover-button btn-secondary ai-assistant-btn"
              onClick={() => setShowChatbot(true)}
            >
              <span className="btn-text">Ask Our AI Assistant </span>
              <span className="zap-icon"> </span>
            </button>
          </div>
        </div>

        {/* Right Visual/Stats Section */}
        <div className="hero-right-visual" style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <img 
            src={heroImage} 
            alt="AI Platform Visualization"
            style={{
              maxWidth: "100%",
              height: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </div>
      <ChatbotModal 
        show={showChatbot} 
        onHide={() => setShowChatbot(false)}
      />
    </div>
  );
};

export default HeroSection;